<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="management" @selected="switchTab"></TabsWidget>
      <div class="tab-options">
        <b-button type="is-info" outlined @click="addNewVotingSession()">ADD VOTING
          SESSION</b-button>
      </div>
    </div>
    <div class="wrapper-body">
      <!-- Voting session-->
      <div class="left-panel">
        <div class="left-panel-header">
          <div class="left-panel-header-title">
            <span>VOTING SESSIONS</span>
          </div>
          <div class="left-panel-header-option"></div>
        </div>
        <div class="left-panel-body">
          <div class="voting-session-item" v-for="(item, index) in voting_sessions" :key="index" :class="{
            active:
              selected_voting_session &&
              selected_voting_session.id == item.id,
          }">
            <div @click="selectVotingSession(item)" v-if="item.cover_image"
              class="voting-session-item-cover-image-panel">
              <img :src="$store.state.ASSETS_BASE_URL +
                '/assets/uploaded/' +
                item.cover_image
                " />
            </div>
            <div class="voting-session-item-top-panel">
              <div @click="selectVotingSession(item)" class="voting-session-item-image">
                <img :src="$store.state.ASSETS_BASE_URL +
                  '/assets/uploaded/' +
                  item.logo
                  " />
              </div>
              <div @click="selectVotingSession(item)" class="voting-session-item-title">
                <span>{{ item.title }}</span>
              </div>
              <div class="voting-session-item-option">
                <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                  <template #trigger>
                    <b-icon icon="dots-vertical"></b-icon>
                  </template>

                  <b-dropdown-item @click="duplicateVotingSession(item)"
                    aria-role="listitem">Duplicate</b-dropdown-item>

                  <b-dropdown-item v-clipboard:copy="`${$store.state.ADMIN_BASE_URL}participant/login/${item.id}`
                    " v-clipboard:success="onCopy" v-clipboard:error="onCopyError" aria-role="listitem">Copy
                    Participant
                    Login Link
                  </b-dropdown-item>

                  <b-dropdown-item v-clipboard:copy="`${$store.state.SITE_BASE_URL}voting/${item.slug}`
                    " v-clipboard:success="onCopy" v-clipboard:error="onCopyError" aria-role="listitem">Copy Session
                    Link</b-dropdown-item>

                  <b-dropdown-item v-clipboard:copy="`${$store.state.SITE_BASE_URL}nomination/${item.slug}`
                    " v-clipboard:success="onCopy" v-clipboard:error="onCopyError" aria-role="listitem">Copy
                    Nomination Link</b-dropdown-item>

                  <b-dropdown-item v-clipboard:copy="`${$store.state.SITE_BASE_URL}voting/embend/${item.slug}`
                    " v-clipboard:success="onCopy" v-clipboard:error="onCopyError" aria-role="listitem">Copy Embend
                    Link</b-dropdown-item>

                  <b-dropdown-item @click="reindexVotingParticipants(item)" aria-role="listitem">Reindex
                    Participants</b-dropdown-item>

                  <b-dropdown-item @click="updateVotingSession(item)" aria-role="listitem">Update</b-dropdown-item>
                  <b-dropdown-item @click="deleteVotingSession(item)" aria-role="listitem">Delete</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div @click="selectVotingSession(item)" class="voting-session-item-bottom-panel">
              <div class="voting-session-item-bottom-left">
                <div class="voting-session-item-startdate">
                  <b-icon icon="calendar"></b-icon>
                  <span>Start Date:
                    {{
                      moment(item.start_time).format("MMMM Do YYYY, h:mm A")
                    }}</span>
                </div>
                <div class="voting-session-item-enddate">
                  <b-icon icon="calendar"></b-icon>
                  <span>End Date:
                    {{
                      moment(item.end_time).format("MMMM Do YYYY, h:mm A")
                    }}</span>
                </div>
              </div>
              <div class="voting-session-item-bottom-right">
                <div class="voting-session-tags">
                  <b-tag v-if="item.status == 'public'" type="is-success" size="is-small">Public</b-tag>
                  <b-tag v-if="item.status == 'unlisted'" type="is-danger" size="is-small">Unlisted</b-tag>
                  <b-tag :type="getPhaseType(item.phase)" size="is-small">
                    {{ getPhaseText(item.phase) }}
                  </b-tag>
                  <b-tag v-if="item.rewards_enabled" type="is-warning" size="is-small">
                    Rewards Enabled
                  </b-tag>
                  <b-tag v-if="item.sponsors && JSON.parse(item.sponsors || '[]').length > 0" type="is-info"
                    size="is-small">
                    {{ JSON.parse(item.sponsors || '[]').length }} Sponsors
                  </b-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Voting Categories -->
      <VotingCategories v-if="selected_voting_session" :session="selected_voting_session"
        @selected="onSelectVotingCategory" class="" @close="closeCategories"></VotingCategories>
      <div v-else class="middle-panel-notfound">
        <widgetNotfound v-if="!selected_voting_session" title="No Categories "
          subtitle="No categories found, Select a voting session to see the categories"></widgetNotfound>
      </div>
      <!-- Voting Participants -->
      <VotingParticipants v-if="selected_voting_session && selected_voting_category" :session="selected_voting_session"
        :category="selected_voting_category" @close="closeParticipant"></VotingParticipants>
      <div v-else class="rigth-panel-notfound">
        <widgetNotfound v-if="!selected_voting_session" title="No Participants"
          subtitle="No participants found, Select a voting session to see the participants"></widgetNotfound>
        <widgetNotfound v-if="selected_voting_session && !selected_voting_category" title="No Participants"
          subtitle="No participants found, Select a voting category to see the participants"></widgetNotfound>
      </div>
    </div>

    <!-- Add voting session modal -->
    <addNewVotingSessionModal v-if="show_add_vote_session_modal && channel_details" :channel="channel_details"
      :value="selected_voting_session" @saved="onVotingSessionSaved()" @close="show_add_vote_session_modal = false">
    </addNewVotingSessionModal>
  </div>
</template>

<script>
import addNewVotingSessionModal from "./modals/addNewVotingSessionModal.vue";
import VotingCategories from "./components/VotingCategories.vue";
import VotingParticipants from "./components/VotingParticipants.vue";
import TabsWidget from "./components/TabsWidget.vue";
export default {
  components: {
    addNewVotingSessionModal,
    VotingCategories,
    VotingParticipants,
    TabsWidget,
  },
  sockets: {},
  data: () => ({
    channel_details: null,
    loading_channel_details: false,
    show_add_vote_session_modal: false,
    selected_voting_session: null,
    loading_voting_session: false,
    voting_sessions: [],
    selected_voting_category: null,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getMyChannelDetails();
  },
  methods: {
    duplicateVotingSession(item) {
      let vm = this;
      vm.$store
        .dispatch("VOTING_DUPLICATE_SESSION", {
          id: item.id,
        })
        .then((response) => {
          vm.selected_voting_session = null;
          vm.selected_voting_category = null;
          vm.getMyVotingSessions();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    closeParticipant() {
      let vm = this;
      vm.selected_voting_category = null;
    },
    closeCategories() {
      let vm = this;
      vm.selected_voting_session = null;
    },
    onSelectVotingCategory(item) {
      let vm = this;
      vm.selected_voting_category = item;
    },
    selectVotingSession(item) {
      let vm = this;
      vm.selected_voting_session = item;
      vm.selected_voting_category = null;
    },
    reindexVotingParticipants(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Reindex Participants",
        message:
          "Are you sure you want to reindex the participants of this voting session? This action cannot be undone and will change partcipants number which will affect the voting on USSD",
        confirmText: "Reindex",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("VOTING_REINDEX_SESSION", {
              id: item.id,
            })
            .then((response) => {
              vm.selected_voting_session = null;
              vm.selected_voting_category = null;
              vm.getMyVotingSessions();
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        },
      });
    },
    deleteVotingSession(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Deleting Voting Session",
        message:
          "Are you sure you want to <b>delete</b> this voting session? This action cannot be undone.",
        confirmText: "Delete Session",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("VOTING_DELETE_MY_VOTING_SESSION", {
              id: item.id,
            })
            .then((response) => {
              vm.selected_voting_session = null;
              vm.selected_voting_category = null;
              vm.getMyVotingSessions();

              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Something went wrong, Contact your administrator",
              });
            });
        },
      });
    },
    updateVotingSession(item) {
      let vm = this;
      vm.selected_voting_session = item;
      vm.show_add_vote_session_modal = true;
    },
    addNewVotingSession() {
      let vm = this;
      vm.selected_voting_session = null;
      vm.show_add_vote_session_modal = true;
    },
    onVotingSessionSaved() {
      let vm = this;
      vm.show_add_vote_session_modal = false;
      vm.getMyVotingSessions();
    },
    getMyVotingSessions() {
      let vm = this;
      vm.loading_voting_session = true;
      vm.$store
        .dispatch("VOTING_GET_MY_VOTING_SESSIONS")
        .then((response) => {
          vm.loading_voting_session = false;
          vm.voting_sessions = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_voting_session = false;
        });
    },
    getMyChannelDetails() {
      let vm = this;
      vm.loading_channel_details = true;
      vm.loading_voting_session = true;
      vm.$store
        .dispatch("CHANNEL_GET_MY_DETAILS")
        .then((response) => {
          vm.loading_channel_details = false;
          vm.channel_details = response.data.return;
          vm.getMyVotingSessions();
        })
        .catch(({ response }) => {
          vm.loading_channel_details = false;
        });
    },
    onCopy() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Link copied to clipboard",
        type: "is-success",
      });
    },
    onCopyError() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Failed to copy",
        type: "is-danger",
      });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    getPhaseType(phase) {
      switch (phase) {
        case 'nomination': return 'is-info';
        case 'voting': return 'is-success';
        default: return 'is-light';
      }
    },
    getPhaseText(phase) {
      switch (phase) {
        case 'nomination': return 'Nomination Phase';
        case 'voting': return 'Voting Phase';
        default: return 'Unknown Phase';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding-left: 6px;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;
      white-space: nowrap;
      margin-right: 20px;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-bottom: 3px solid transparent;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;

    .left-panel {
      height: 100%;
      width: 400px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .left-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;
        background: #fff;
        position: sticky;
        top: 0;

        .left-panel-header-title {
          font-size: 14px;
          font-weight: 600;
        }

        .left-panel-header-option {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .h-spacer {
            margin-right: 10px;
          }
        }
      }

      .left-panel-body {
        overflow-y: auto;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;

        .voting-session-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          border-bottom: 1px solid #ddd;
          cursor: pointer;
          margin-bottom: 10px;

          &:hover {
            background: #fff;
          }

          &.active {
            background: #fff;
          }

          .voting-session-item-cover-image-panel {
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .voting-session-item-top-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .voting-session-item-image {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .voting-session-item-title {
              font-size: 14px;
              font-weight: 600;
              color: #333;
              width: calc(100% - 60px);
              padding: 0px 10px;
            }

            .voting-session-item-option {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10px;
            }
          }

          .voting-session-item-body-panel {
            padding: 0px 10px;
          }

          .voting-session-item-bottom-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .voting-session-item-bottom-left {
              display: flex;
              flex-direction: column;

              .voting-session-item-startdate,
              .voting-session-item-enddate {
                font-size: 12px;
                color: #333;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
              }
            }

            .voting-session-item-bottom-right {
              display: flex;
              align-items: center;
              justify-content: center;

              .voting-session-tags {
                display: flex;
                flex-direction: column;
                gap: 4px;
                align-items: flex-end;
              }
            }
          }
        }
      }
    }

    .middle-panel-notfound {
      height: 100%;
      width: 400px;
      overflow-y: auto;
      border-left: 1px solid #ddd;
      display: flex;
      align-items: center;
      justify-content: center;

      @media (max-width: 592px) {
        position: absolute;
        background: white;
        z-index: 10;
        top: 60px;
        right: 0;
        width: 350px;
        opacity: 0;
        pointer-events: none;
      }
    }

    .rigth-panel-notfound {
      width: calc(100% - 800px);
      height: 100%;
      border-left: 1px solid #ddd;
      display: flex;
      align-items: center;
      justify-content: center;

      @media (max-width: 1184px) {
        position: absolute;
        background: white;
        z-index: 10;
        top: 60px;
        right: 0;
        width: 350px;
        opacity: 0;
        pointer-events: none;
      }
    }
  }
}
</style>
